import { Edit, TabbedForm } from 'react-admin';
import { ManufacturerResource } from '../../Entities/Manufacturer';
import KeywordsTab from './Forms/KeywordsTab';
import SummaryTab from './Forms/SummaryTab';
import EditToolbar from '../../Components/EditToolbar';
import { ReactElement } from 'react';

export default function ManufacturerEdit(): ReactElement {
  return (
    <Edit<ManufacturerResource> mutationMode="pessimistic">
      <TabbedForm toolbar={<EditToolbar />}>
        <SummaryTab />
        <KeywordsTab />
      </TabbedForm>
    </Edit>
  );
}
